// Too much files to change
import { Component } from 'preact'
import WidgetColumn from './widget-column'
import { pageOptions } from './toolbar'
import { ServerGenericPageWidget, LEFT_CONTAINER, SIDEBAR_CONTAINER } from '@insided/customization'
import { PageWidget } from './WidgetConfiguration'

export type ContainerEditorWidget = PageWidget<
  'container_2_1',
  {
    column_1: ServerGenericPageWidget[]
    column_2: ServerGenericPageWidget[]
  }
>

interface Props {
  parentEl: HTMLElement
  homepageElement: ContainerEditorWidget
  onChildEnter: () => void
  onChildLeave: () => void
  onChange: (change: ElementChange) => void
  controlUrl: string
  currentPage: pageOptions
}

interface State {
  editingId: string | null
  column_1: ServerGenericPageWidget[]
  column_2: ServerGenericPageWidget[]
}

const assignIds = (el: ServerGenericPageWidget, idx: number) => ({ ...el, id: idx })

export type ElementChange = Pick<ServerGenericPageWidget, 'type' | 'config' | 'title'>

export interface DonePayload {
  idx: number
  element: ElementChange
}
export interface MovePayload {
  direction: 'up' | 'down'
}
export type VisiblePayload = boolean

export default class ContainerEditor extends Component<Props, State> {
  constructor(props: Props) {
    super()

    this.state = {
      editingId: null,
      column_1: props.homepageElement.config.column_1.map(assignIds),
      column_2: props.homepageElement.config.column_2.map(assignIds)
    }
    this.fireOnChange = this.fireOnChange.bind(this)
  }

  fireOnChange() {
    this.props.onChange({
      type: 'container_2_1',
      title: 'Container 2:1',
      config: {
        column_1: this.state.column_1,
        column_2: this.state.column_2
      }
    })
  }

  render() {
    const { homepageElement, controlUrl, currentPage } = this.props
    return (
      <div>
        <WidgetColumn
          container={`.widget-container--index-${homepageElement.id} .widget-container--container-2-1-column_1`}
          classPrefix='widget-container--container-2-1-column_1-index-'
          elements={this.state.column_1}
          controlUrl={controlUrl}
          containerComponent={LEFT_CONTAINER}
          onChange={(column1) => this.setState({ column_1: column1 }, this.fireOnChange)}
          onChildMouseOut={this.props.onChildLeave}
          onChildMouseOver={this.props.onChildEnter}
          currentPage={currentPage}
          nested
        />

        <WidgetColumn
          container={`.widget-container--index-${homepageElement.id} .widget-container--container-2-1-column_2`}
          controlUrl={controlUrl}
          classPrefix='widget-container--container-2-1-column_2-index-'
          elements={this.state.column_2}
          containerComponent={SIDEBAR_CONTAINER}
          onChange={(column2) => this.setState({ column_2: column2 }, this.fireOnChange)}
          onChildMouseOut={this.props.onChildLeave}
          onChildMouseOver={this.props.onChildEnter}
          currentPage={currentPage}
          nested
        />
      </div>
    )
  }
}
